//
// close error message on button click
//

var toggleErrorMessageVisibility = (function () {
    'use strict';

    //Variables
    var closeButtonSelector = '.experian-alert__close';
    var closeButton = document.querySelectorAll(closeButtonSelector);

    // Methods
    if (closeButton.length) {
        $(closeButton).each(function (index, el) {
            $(el).on('click', function () {
                $(this).closest('.experian-alert').hide();
            });
        });
    }
})();